/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Modal_Confirmationlabel3Inputs */

const en_coinvestments_canceldeal_modal_confirmationlabel3 = /** @type {(inputs: Coinvestments_Canceldeal_Modal_Confirmationlabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type 'cancel' to confirm`)
};

/**
* | output |
* | --- |
* | "Type 'cancel' to confirm" |
*
* @param {Coinvestments_Canceldeal_Modal_Confirmationlabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_modal_confirmationlabel3 = /** @type {((inputs?: Coinvestments_Canceldeal_Modal_Confirmationlabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Modal_Confirmationlabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_modal_confirmationlabel3(inputs)
});
export { coinvestments_canceldeal_modal_confirmationlabel3 as "coInvestments_cancelDeal_modal_confirmationLabel" }